import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cut_ic_chervon",
  "use": "icon-cut_ic_chervon-usage",
  "viewBox": "0 0 10 18",
  "content": "<symbol viewBox=\"0 0 10 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cut_ic_chervon\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-7-4.09h24v26H-7z\" /><path stroke=\"currentColor\" stroke-width=\"2\" d=\"m1 1.326 7 7.583-7.071 7.66\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol